// Map error codes to user-friendly messages
const ERROR_MESSAGES = {
    400: "Bad Request. Please check your input.",
    401: "Unauthorized. Please log in again.",
    403: "Forbidden. You do not have access to this resource.",
    404: "Resource not found.",
    500: "Internal Server Error. Please try again later.",
    503: "Service Unavailable. Please try again later.",
    default: "An unexpected error occurred. Please try again.",
};

// Simple console error logger
const logError = (message) => {
    console.error(message);
   // logError("Network Error. Please check your connection.");
    return { status: 0, message:message };
    // You can add toast notifications here later when react-toastify is installed
    // toast.error(message);
};

// Generic error handler function
const handleError = (error) => {
    // Axios timeout (ECONNABORTED) or fetch aborts
    if (error.code === "ECONNABORTED" || String(error.message || "").toLowerCase().includes("timeout")) {
        logError("Request timed out. Please try again.");
        return { status: 408, message: "Request timed out. Please try again." };
    }

    const status = error.response?.status;
    const data = error.response?.data || {};

    // Detect if this error came from the login request or we're on the login page
    const reqUrl = error.config?.url || "";
    const reqMethod = (error.config?.method || "").toLowerCase();
    const isLoginAttempt = reqMethod === "post" && reqUrl.includes("/login");
    const onLoginPage = typeof window !== "undefined" && window.location?.pathname === "/login";

    // Build a message (prefer server message)
    let message = data.message || ERROR_MESSAGES[status] || ERROR_MESSAGES.default;

    // Friendly message for wrong credentials on login
    if ((status === 400 || status === 401) && (isLoginAttempt || onLoginPage)) {
        message = "Incorrect email or password. Please try again.";
    }

    if (status) {
        // Show notification
        logError(message);

        switch (status) {
            case 401:
                // Clear token but don't redirect to login
                localStorage.removeItem("authToken");
                break;
            case 403:
                // Treat forbidden on protected endpoints as invalid session
                localStorage.removeItem("authToken");
                break;
            case 503:
                if (!onLoginPage) {
                    window.location.href = "/503";
                }
                break;
            default:
                break;
        }

        // Keep the server's error code (e.g. SUBSCRIPTION_EXISTS) so callers can tell errors apart
        return { status, message, ...(data.code && { code: data.code }) };
    }

    if (error.message === "Network Error") {
        logError("Network Error. Please check your connection.");
        return { status: 0, message: "Network Error" };
    }

    logError(ERROR_MESSAGES.default);
    return { status: -1, message: ERROR_MESSAGES.default };
};

export default handleError;
